import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Service } from '../../../../../components/actionable-filter-pill/connected/shipping/service';
import { SERVICE } from '../../../../../filters/constants';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: SERVICE,
  displayName: <FormattedMessage {...messages.service} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ServiceId',
  expectsArgumentAsArray: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
  allowsMultipleSelection: true,
  actionableFilterPill: Service,
};
